import "../../_namespaces.js";
import "../../_generated_templates.js";
import "./choice.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseSelectOneChoice = class ResponseSelectOneChoice extends (
  AssessmentViewer.Views.ResponseChoice
) {};
AssessmentViewer.Views.ResponseSelectOneChoice.prototype.className = "response-select-one-choice";
AssessmentViewer.Views.ResponseSelectOneChoice.prototype.template = _.template(
  AssessmentViewer.Templates.Response.select_one_choice,
);
